let { monkey } = require('baobab');
let _ = require('lodash');
let numeral = require('numeral');

module.exports = {
    /**
     * Форматируем цены
     * @param {Object} state
     */
    formatPrices (state) {
        state.set(['data', 'computed', 'prices'], monkey(
            ['data', 'prices'],
            (prices = []) => {
                if (prices.length == 0)
                {
                    return prices;
                }

                let result = _.map(prices, (x) => {
                    if (Array.isArray(x.name)) {
                        let xNew = _.cloneDeep(x);
                        xNew.name = 'Базовые поля (' + _.map(x.name, (x) => x.toLowerCase()).join(", ") + ')';
                        return xNew;
                    }
                    return x;
                });

                return result;
            }
        ));
    },

    /**
     * Форматируем скидки
     * @param {Object} state
     */
    formatDiscounts (state) {
        state.set(['data', 'computed', 'discounts'], monkey(
            ['data', 'discounts'],
            (discounts = []) => {
                if (discounts.length == 0)
                {
                    return discounts;
                }

                let result = [];
                for (var i = 0; i < discounts.length - 1; i++) {
                    result.push({
                        lowerBound: `от ${discounts[i].lowerBoundOfRowsAmount} до ${discounts[i+1].lowerBoundOfRowsAmount}`,
                        percentage: discounts[i].percentage
                    });
                }
                result.push({
                    lowerBound: 'более ' + discounts[discounts.length - 1].lowerBoundOfRowsAmount,
                    percentage: discounts[discounts.length - 1].percentage
                });

                return _.filter(result, (x) => x.percentage > 0);
            }
        ));
    },

    /**
     * Удобно раскидываем колонки
     * @param {Object} state
     */
    formatExportColumns (state) {
        state.set(['data', 'computed', 'columns'], monkey(
            ['data', 'columns'],
            (columns = []) => {
                let basic = _.filter(columns, (x) => x.isBasic);
                let optional = _.filter(columns, (x) => x.isBasic == false);
                return {
                    basic: _.map(basic, (x) => ({ name: x.name.toLowerCase() })),
                    optional: _.map(optional, (x) => ({ name: x.name.toLowerCase() }))
                };
            }
        ));
    }
};



// WEBPACK FOOTER //
// ./actions/computed/data.js